export default __webpack_public_path__ + "static/media/halfGlobe.a051548c.svg";